import { render, staticRenderFns } from "./SettingTreeTable.vue?vue&type=template&id=1142f0c4&"
import script from "./SettingTreeTable.vue?vue&type=script&lang=js&"
export * from "./SettingTreeTable.vue?vue&type=script&lang=js&"
import style0 from "./SettingTreeTable.vue?vue&type=style&index=0&id=1142f0c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports